import { CategoryDto as AdminCategoryDto } from "@generated/admin";
import { CategoryDto } from "@generated/front";
import axios from "axios";
import { type ClassValue, clsx } from "clsx";
import { saveAs } from "file-saver";
import { twMerge } from "tailwind-merge";

import { Paginated } from "../types/common";

/**
 * 클래스 값들을 결합하고 병합합니다.
 *
 * 1. clsx: 동적으로 클래스 문자열을 결합합니다.
 * 2. tailwind-merge: Tailwind CSS 클래스를 병합합니다.
 *
 * 예시:
 * isActive가 true일 경우,
 * cn('bg-white', isActive && 'text-content-primary', 'p-4 p-2') -> 'bg-white text-content-primary p-2'
 *
 * @param inputs - 결합할 클래스 값들의 배열.
 * @returns 병합된 클래스 문자열.
 */

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export function pageRange(length: number, start = 0) {
  return Array.from({ length }, (_, i) => i + start);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getNextPageParam(lastPage: Paginated<any>) {
  const {
    pagination: { currentPage, totalPage },
  } = lastPage;
  const nextPage = currentPage + 1;
  return nextPage <= totalPage ? nextPage : undefined;
}

export const extractFileName = (url: string): string => {
  const segments = url.split("/");
  const fileName = segments.pop();

  return fileName || "";
};

export const downloadFile = async (fileUrl: string) => {
  try {
    const response = await axios.get(fileUrl, {
      responseType: "blob",
    });

    const fileName = extractFileName(fileUrl);
    saveAs(response.data, fileName);
  } catch (error) {
    console.error("파일 다운로드 중 에러가 발생했습니다:", error);
  }
};

export const getCategoryName = (
  id: string | number,
  categories: CategoryDto[] | AdminCategoryDto[]
) => {
  const category = categories.filter((cat) => String(cat.id) === String(id));
  if (category.length === 0) return "";
  return category[0].name;
};
